<template>
  <div>
    <div class="container" @click="showWxDialog">
      点击关注“部落小助手”，第一时间知道谁喜欢了你
      <img src="~@/assets/img/arrow-enter2.png" alt="" class="icon" />
    </div>
    <AccelerateAduit v-model="isShowAccelerate" @confirm="isShowAccelerate = false" :isBaseData="isBaseData"
      @close="isShowAccelerate = false" />
  </div>
</template>

<script>
import AccelerateAduit from '@/components/dialog/wxDialog'

export default {
  components: {
    AccelerateAduit
  },
  props: {},
  data () {
    return {
      isShowAccelerate: false,
      isBaseData: false
    }
  },
  watch: {},
  computed: {},
  methods: {
    showWxDialog () {
      this.isShowAccelerate = true
    }
  }
}
</script>
<style lang="scss">
.container {
  margin: 0 auto;
  width: 670px;
  height: 80px;
  border-radius: 8px;
  background: linear-gradient(
    131deg,
    rgba(255, 186, 215, 1) 0%,
    rgba(255, 62, 144, 1) 100%
  );

  font-size: 26px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  display: flex;
  justify-content: center;
  align-items: center;

  .icon {
    display: inline-block;
    vertical-align: middle;
    width: 15px;
    margin-left: 32px;
  }
}
</style>
